import { getSubscribeNumber, submitScribe } from '@elem/Service/delta-pro-ultra';
import Close from '@elem/SVGIcon/DeltaProUltra/Close';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getPagesPrivacyPolicy } from '@/utils/common';

export default function E({ number, buyLink }: any) {
    const { useLang, useRouter, useEffect, useState, Link, gtm } = useGlobal();
    const { t } = useLang('delta_pro_ultra.prelaunch');
    const { locale } = useRouter();

    const [num, setNum] = useState(0);
    const [input, setInput] = useState('');
    const [inputVal, setInputVal] = useState('');
    const [check, setCheck] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showMsg, setShowMsg] = useState('');

    const cards: any[] = [
        {
            svg: '/responsive/picture/delta-pro-ultra/prelaunch/5_1.png',
            btn: t('secE_card1_btn'),
            link: t('secE_card1_link'),
            text: t('secE_card1_text'),
        },
        // {
        //     svg: '/responsive/picture/delta-pro-ultra/prelaunch/5_2.png',
        //     btn: t('secE_card2_btn'),
        //     link: t('secE_card2_link'),
        //     text: t('secE_card2_text'),
        // },
    ];

    const handleInputChange = (v: any) => {
        setInput(v.target.value);
        setInputVal(v.target.value);
    };

    const handleCheck = () => {
        setCheck(!check);
        if (!check && showMsg) {
            setShowMsg('');
        }
        if (check && !showMsg) {
            setShowMsg(t('common_agree_tip'));
        }
    };

    const handleSubmit = async () => {
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (!input.trim()) {
            return setShowMsg(t('common_email_tip_null'));
        }
        if (!emailRegex.test(input.trim())) {
            return setShowMsg(t('common_email_tip_format'));
        }
        if (!check) {
            return setShowMsg(t('common_agree_tip'));
        }
        try {
            const res = await submitScribe(
                locale,
                { email: input.trim() },
                {
                    sector_name: `DPU_${t('secE_title')}`,
                    entry_position: '5',
                },
            );
            if (res?.code === '0') {
                // setShowModal(true);
                setInput('');
                setShowMsg(t('secE_submit_success'));
                try {
                    const res = await getSubscribeNumber(locale);
                    if (res?.code !== '0') {
                        console.error(res?.message);
                    } else {
                        setNum(res?.data);
                    }
                } catch (e) {
                    console.error(e);
                }
                try {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'activity_submit',
                        button_name: t('common_btn'),
                        status: 'success',
                        tag: 'Agree',
                    });
                } catch (e) {
                    console.error(e);
                }
            } else {
                setShowMsg(res?.message);
                console.error(res?.message);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('common_btn'),
                    status: 'fail',
                    tag: 'Agree',
                });
            }
        } catch (e) {
            console.error(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('common_btn'),
                status: 'fail',
                tag: 'Agree',
            });
        } finally {
            window?.fbq && window?.fbq('track', 'Lead');
        }
    };

    const handleJoin = async () => {
        // try {
        //     const res = await submitJoin(locale, { email: inputVal.trim() });
        //     if (res?.code !== '0') {
        //         console.log(res?.message);
        //     }
        // } catch (e) {
        //     console.error(e);
        // }
        // try {
        //     gtm.push({
        //         event: 'uaEvent',
        //         event_name: 'activity_join',
        //         button_name: t('common_modal_btn'),
        //     });
        // } catch (e) {
        //     console.error(e);
        // }
        setShowModal(false);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: 'DELTA Pro Ultra coupons',
                position: 'Early Bird',
            });
        } catch (e) {
            console.error(e);
        }
        return true;
    };

    useEffect(() => {
        (async () => {
            try {
                const res = await getSubscribeNumber(locale);
                if (res?.code === '0') {
                    setNum(res?.data);
                } else {
                    console.error(res?.message);
                }
            } catch (e) {
                console.error(e);
            }
        })();
    }, []);

    useEffect(() => {
        setNum(number);
    }, [number]);

    return (
        <div id="delta-pro-ultra-prelaunch-E" className={`delta-pro-ultra-E ${css['delta-pro-ultra-E']}`}>
            <div className="ef-box">
                <p className="title">{t('secE_title')}</p>
                <div className="control-box">
                    <p className="card-title">
                        {t.rich('secE_card1_title', {
                            num,
                            n: (text: string) => <span className="no-wrap">{text}</span>,
                        })}
                    </p>
                    <div className="control">
                        <input type="text" className="input" value={input} onChange={handleInputChange} placeholder={t('common_placeholder')} />
                        <button className="subscribe" onClick={handleSubmit}>
                            {t('common_btn')}
                        </button>
                    </div>
                    {showMsg && <p className={`error-msg ${showModal ? 'success' : 'error'}`}>{showMsg}</p>}
                    <div className="agreement">
                        <input type="checkbox" className="agree-check" id="agree" checked={check} onChange={handleCheck} />
                        <label htmlFor="agree" className="agree-label">
                            {t.rich('common_agree', {
                                a1: (text: string) => (
                                    <Link className="link" href={`https://${locale}.ecoflow.com/pages/terms-of-use`}>
                                        {text}
                                    </Link>
                                ),
                                a2: (text: string) => (
                                    <Link className="link" href={getPagesPrivacyPolicy(locale)}>
                                        {text}
                                    </Link>
                                ),
                            })}
                        </label>
                    </div>
                </div>
                <ul className="cards">
                    {cards?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            <div className="card-img">
                                <EFPicture src={card?.svg} alt={card?.text} />
                            </div>
                            <Link
                                className="card-link"
                                href={card?.link}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'activity_button',
                                    page_name: 'DELTA Pro Ultra Pre Launch',
                                    // https://docs.google.com/spreadsheets/d/11MquSBS3Lo7WJsZg_bbcDfNOefHKrr0P_YgD7qeBGFQ/edit#gid=370435365
                                    list_name:
                                        // 'Join us for insider access, exclusive benefits, and tips and tricks. Be a part of EcoFlow and power your business growth',
                                        card?.text,
                                    button_name: card?.btn,
                                    function: k === 0 ? 'Join Community' : 'Become Dealer',
                                }}
                            >
                                {card?.btn}
                            </Link>
                            <p className="card-text">{card?.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={`modal ${showModal ? 'show' : ''}`}>
                <div className="modal-content">
                    <Close id="E" className="close" onClick={() => setShowModal(false)} />
                    <p className="modal-title">{t('common_modal_title')}</p>
                    <p className="modal-text">
                        {t.rich('common_modal_text', {
                            n: (text: string) => <span className="no-wrap">{text}</span>,
                        })}
                    </p>
                    <a
                        // href={'https://bit.ly/3PofSeh'}
                        href={buyLink}
                        className="modal-btn"
                        target="_blank"
                        onClick={handleJoin}
                        rel="noreferrer"
                    >
                        {t('common_modal_btn')}
                    </a>
                </div>
            </div>
        </div>
    );
}
